import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-enterprise';

@Component({
  standalone: true,
  selector: 'app-ag-grid-select-all',
  templateUrl: './ag-grid-select-all.component.html',
  styleUrls: ['./ag-grid-select-all.component.scss'],
  imports: [CommonModule, MatMenuModule, MatCheckboxModule, FormsModule, ReactiveFormsModule]
})
export class AgGridSelectAllComponent implements IHeaderAngularComp {
  headerName: string;
  isChecked: boolean;
  isSelectAll: boolean;
  isIndeterminate: boolean;
  showCheckBox: boolean = true;
  sortIcon: string = 'none';
  sortSubIcon: string = 'none';
  params: IHeaderParams;
  selectedNodesLength = 0;
  perPageSize: any;
  allCaseCount: any;

  /* istanbul ignore next */
  agInit(params: IHeaderParams | any): void {
    this.params = params;
    this.headerName = this.params?.displayName;

    // Add event listener for selectionChanged
    this.params.api.addEventListener('selectionChanged', () => {
      setTimeout(() => { this.setCheckboxState(); }, 200);
    });

    // Add event listener for paginationChanged
    this.params.api.addEventListener('paginationChanged', () => {
      setTimeout(() => { this.setCheckboxState(); }, 100);
    });
  }

  /** Method to toggle the select all checkbox */
  toggleSelect(): void {
    this.setCheckboxState();
  }

  /** Get the header to refresh. Gets called whenever Column Defs are updated. */
  refresh(params: IHeaderParams): boolean {
    return false;
  }

  /** selectAllDataAGGrid  */
  selectAllDataAGGrid(isSelectAll: boolean) {
    this.isChecked = isSelectAll;
    this.isSelectAll = isSelectAll;
    const event: any = {
      type: 'selectionChanged',
      api: this.params.api,
      isSelectAll: isSelectAll,
      isChecked: this.isChecked
    };

    this.params?.api?.dispatchEvent(event);
  }

  /* istanbul ignore next */
  setCheckboxState(): void {//NOSONAR
    // Check if params are available
    if (this.params) {
      // Get the selected nodes length
      this.selectedNodesLength = this.params?.api?.getSelectedNodes()?.length;
      // Display the selected nodes length
      const displaySelectedRowCount: number = this.params?.column?.getColDef().headerComponentParams?.selectedNodesLength;
      // Get the rendered nodes length
      const renderedNodesLength: number = this.params?.api?.getDisplayedRowCount();
      // Get the page size and assign it to perPageSize
      const pageSize: number = this.params?.api?.paginationGetPageSize();
      this.perPageSize = pageSize;
      // Get the current page
      const currentPage = this.params?.api?.paginationGetCurrentPage();
      const startResult = currentPage * pageSize + 1;
      const endResult = Math.min(startResult + pageSize - 1);
      const noOfRowsInthisPage = (endResult - startResult + 1);
      // Check if perPageSize is greater than noOfRowsInthisPage
      if (this.perPageSize > noOfRowsInthisPage) {
        this.perPageSize = noOfRowsInthisPage;
      }
      // Check if selectedNodesLength is 0 and displaySelectedRowCount is greater than or equal to pageSize
      if (this.selectedNodesLength == 0 && displaySelectedRowCount && displaySelectedRowCount >= pageSize)
        this.selectedNodesLength = displaySelectedRowCount;

      // Check if selectedNodesLength is greater than 0 and displaySelectedRowCount is greater than or equal to pageSize
      this.isSelectAll = this.isSelectAll ? this.selectedNodesLength > 0 && this.selectedNodesLength === renderedNodesLength : false;

      // Check if selectedNodesLength is greater than 0 and displaySelectedRowCount is greater than or equal to pageSize
      if (this.isSelectAll) {
        this.isChecked = this.selectedNodesLength > 0 && this.selectedNodesLength === renderedNodesLength;
      }
      else {
        // Check if selectedNodesLength is greater than 0 and displaySelectedRowCount is greater than or equal to pageSize
        const currentPage: number = this.params?.api?.paginationGetCurrentPage();
        const startIndex: number = (currentPage * pageSize);
        const endIndex: number = (currentPage + 1) * pageSize;
        let allPageData = [];
        // Get all the nodes
        this.params?.api.forEachNode(node => {
          allPageData.push(node);
        });
        // Get the current page data
        const currentPageData = allPageData.slice(startIndex, endIndex);
        // Set header checkbox state
        this.isChecked = this.params?.column?.getColDef()?.headerComponentParams?.IsSelectAllPageRows
          || ((currentPageData != undefined && currentPageData.length > 0) ? !currentPageData.find(x => !x.selected) :
            !allPageData.find(x => !x.selected));
      }
    }
  }
}
